import { create } from 'zustand';

interface ReportExportAvailabilityState {
  /** Campaigns whose last export start was refused (the kill switch is off or storage is missing). Session-only. */
  unavailableCampaignIds: ReadonlySet<string>;
  markUnavailable: (campaignId: string) => void;
  clearUnavailable: (campaignId: string) => void;
}

export const useReportExportAvailabilityStore = create<ReportExportAvailabilityState>((set) => ({
  unavailableCampaignIds: new Set<string>(),
  markUnavailable: (campaignId) =>
    set((state) => ({ unavailableCampaignIds: new Set(state.unavailableCampaignIds).add(campaignId) })),
  clearUnavailable: (campaignId) =>
    set((state) => {
      if (!state.unavailableCampaignIds.has(campaignId)) return state;
      const next = new Set(state.unavailableCampaignIds);
      next.delete(campaignId);
      return { unavailableCampaignIds: next };
    }),
}));
